import { moveArrayIndex } from "@/helpers/plan-helper";
import { ExMutationTree } from "vuex";
import { State, Mutations } from "./types";
import {
  savePlanSettings,
  saveGraduateYears,
  getGraduateYears,
  saveInitializeGraduateYears
} from "@/helpers/plan-helper";

const mutations: ExMutationTree<State, Mutations> = {
  updateProjectName(state, payload) {
    if (state.applicationPlan) {
      state.applicationPlan.name = payload.name;
    }
  },
  updatePlan(state, payload) {
    state.applicationPlan = payload.plan;
  },
  updateCompetitorEmbedded(state, payload) {
    const newCompetitorEmbeddeds = [...state.applicationCompetitorEmbeddeds];
    const competitorEmbeddedIndex = newCompetitorEmbeddeds.findIndex(
      competitorEmbedded => {
        return competitorEmbedded.id === payload.competitorEmbedded.id;
      }
    );
    if (competitorEmbeddedIndex > -1) {
      newCompetitorEmbeddeds[competitorEmbeddedIndex] =
        payload.competitorEmbedded;
    } else {
      newCompetitorEmbeddeds.push(payload.competitorEmbedded);
    }
    state.applicationCompetitorEmbeddeds = newCompetitorEmbeddeds;
  },
  deleteCompetitorEmbedded(state, payload) {
    state.applicationCompetitorEmbeddeds = state.applicationCompetitorEmbeddeds.filter(
      competitor => {
        return competitor.id !== payload.competitorId;
      }
    );
  },
  deleteUniversityEmbedded(state, payload) {
    state.applicationStudentEmbeddeds = state.applicationStudentEmbeddeds.filter(
      student => {
        return student.id !== payload.studentId;
      }
    );
  },
  updateStudentEmbedded(state, payload) {
    const newStudentEmbeddeds = [...state.applicationStudentEmbeddeds];
    const studentEmbeddedIndex = newStudentEmbeddeds.findIndex(
      studentEmbedded => {
        return studentEmbedded.id === payload.studentEmbedded.id;
      }
    );
    if (studentEmbeddedIndex > -1) {
      newStudentEmbeddeds[studentEmbeddedIndex] = payload.studentEmbedded;
    } else {
      newStudentEmbeddeds.push(payload.studentEmbedded);
    }
    state.applicationStudentEmbeddeds = newStudentEmbeddeds;
  },

  deleteStudentEmbedded(state, payload) {
    state.applicationStudentEmbeddeds = state.applicationStudentEmbeddeds.filter(
      studentId => {
        return studentId.id !== payload.studentId;
      }
    );
  },
  updateSelectedEvent(state, payload) {
    state.selectedEvent = payload.event;
  },
  updateSelectedCompany(state, payload) {
    state.selectedCompany = payload.company;
  },
  updateSelectedStudent(state, payload) {
    state.selectedStudent = payload.student;
  },
  updateSpeechBubble(state, payload) {
    state.speechBubble = payload.speechBubble;
  },
  updateSelectedUniversityId(state, payload) {
    state.selectedUniversityId = payload.universityId;
  },
  updateSelectedStudentTrendCategory(state, payload) {
    state.selectedStudentTrendCategory = payload.studentTrendCategory;
  },
  updateEditPlanView(state, payload) {
    state.editPlanView.error = payload.error;
  },
  updateLoading(state, payload) {
    state.isLoading = payload.isLoading;
  },
  updateCreateEventView(state, payload) {
    state.isCreateEventViewVisible = payload.isVisible;
  },
  updateEditEventView(state, payload) {
    state.isEditEventViewVisible = payload.isVisible;
  },
  updateDeleteEventView(state, payload) {
    state.isDeleteEventViewVisible = payload.isVisible;
  },
  updateEditPlanViewVisible(state, payload) {
    state.isEditPlanViewVisible = payload.isVisible;
  },
  updateConfirmDestroyView(state, payload) {
    state.isConfirmDestroyViewVisible = payload.isVisible;
  },
  updateCompetitorView(state, payload) {
    state.isCompetitorViewVisible = payload.isVisible;
  },
  updateUniversityView(state, payload) {
    state.isUniversityViewVisible = payload.isVisible;
  },
  updatePlanSettings(state, { planId, ...settings }) {
    const nextPlanSetting = { ...state.planSettings, ...settings };
    savePlanSettings(nextPlanSetting, planId);
    state.planSettings = nextPlanSetting;
  },
  initializeSelectedGraduateYears(state, { planId, graduateYear }) {
    let graduateYears = getGraduateYears(planId);
    if (!graduateYears) {
      graduateYears = [graduateYear - 2, graduateYear - 1, graduateYear];
      saveInitializeGraduateYears(graduateYears, planId);
    }
    state.selectedGraduateYears = graduateYears;
  },
  updateSelectedGraduateYears(state, { planId, graduateYear }) {
    const graduateYears = saveGraduateYears(graduateYear, planId);
    state.selectedGraduateYears = graduateYears;
  },
  competitorSearchParams(state, payload) {
    state.competitorSearchParams = payload.params;
  },
  getCompanyListSuccess(state, payload) {
    state.companies = payload.companies;
    state.companiesTotal = payload.companiesTotal;
  },
  getUniversityListSuccess(state, payload) {
    state.universities = payload.universities;
  },
  initCompanyList(state, payload) {
    state.companiesTotal = payload.companiesTotal;
    state.companies = payload.companies;
  },
  addCompetitor(state, payload) {
    if (!state.applicationPlan) {
      return;
    }
    const newApplicationPlan = { ...state.applicationPlan };
    const tempCompetitor: Application.TemporaryCompetitor = {
      id: -1,
      company: payload.company,
      created_at: "",
      updated_at: ""
    };
    newApplicationPlan.competitors.push(tempCompetitor);
    state.applicationPlan = newApplicationPlan;
  },
  moveCompetitorEmbeddedIndex(state, payload) {
    const { oldIndex, newIndex } = payload;
    if (!state.applicationPlan) {
      return;
    }

    state.applicationCompetitorEmbeddeds = moveArrayIndex(
      [...state.applicationCompetitorEmbeddeds],
      oldIndex,
      newIndex
    );
  },
  moveStudentEmbeddedIndex(state, payload) {
    const { oldIndex, newIndex } = payload;
    if (!state.applicationPlan) {
      return;
    }

    state.applicationStudentEmbeddeds = moveArrayIndex(
      [...state.applicationStudentEmbeddeds],
      newIndex,
      oldIndex
    );
  }
};

export default mutations;
